// extracted by mini-css-extract-plugin
export default {"insetError":"Alert_insetError__V9O8V","insetSuccess":"Alert_insetSuccess__tx8RO","insetWarn":"Alert_insetWarn__ttwzN","insetBox":"Alert_insetBox__Inj3T"};